var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tab-container__item achievements_tab', { active: _vm.isActive }]},[_c('div',{staticClass:"achievements_container"},_vm._l((_vm.categories),function(category,index){return _c('achievement-category',{key:index,attrs:{"category":category.achievementName,"category-value":category.achievementNameTranslation,"achievements":category.achievementLevelDTOs}})}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba5ab5be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/achievements/AchievementsTab.vue
// module id = null
// module chunks = 